import { ArrowLineUp } from '@phosphor-icons/react';

export default ArrowLineUp;
